import React from 'react';
import styled from 'styled-components';
import { Swipeable } from 'react-swipeable';
import { minBp } from 'src/lib/theme';

export const ButtonWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 30px;
`;

export const Button = styled.button`
  background: #000;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  cursor: pointer;
  margin: 0 20px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;

  &:first-of-type {
    margin-right: 20px;
  }

  &:last-of-type {
    margin-left: 20px;
  }

  @media ${minBp('tabletLarge')} {
    &:first-of-type {
      margin-right: 44px;
    }

    &:last-of-type {
      margin-left: 44px;
    }
  }

  svg {
    fill: #fff;
  }
`;

export const Wrap = styled.div`
  ${({ oneSlide }) => `
  height: ${oneSlide ? '100%' : '375px'};
  width: 100%;
  border-bottom: ${oneSlide ? 'none' : '1px solid rgba(167, 169, 172, 0.5)'};
  
  @media ${minBp('tablet')} {
    height: ${oneSlide ? '100%' : '475px'};
  }

  @media ${minBp('tabletLarge')} {
    height: ${oneSlide ? '100%' : 'auto'};
    border-bottom: none;
    margin-bottom: ${oneSlide ? '0' : '35px'};
  }
`};
`;

export const Slides = styled.div`
  ${({ oneSlide, twoSlides }) => `
  display: flex;
  height: ${oneSlide ? '100%' : 'auto'};
  flex-direction: ${twoSlides ? 'row-reverse' : 'row'};
  
  transform: ${oneSlide ? 'translateX(0%)' : 'translateX(-8.5%)'};
  ${twoSlides ? 'transform: translateX(72%)' : 'translate: inherit'};

  @media ${minBp('additional.mobile')} {
    transform: ${oneSlide ? 'translateX(0%)' : 'translateX(-67.5%)'};
    ${twoSlides ? `transform: translateX(67.5%)` : 'translate: inherit'};
  }

  @media ${minBp('tablet')} {
    transform: ${oneSlide ? 'translateX(0%)' : 'translateX(-80.5%)'};
    ${twoSlides ? `transform: translateX(81.5%)` : 'translate: inherit'};
  }

  @media ${minBp('tabletLarge')} {
    transform: ${oneSlide ? 'translateX(0%)' : 'translateX(-81.5%)'};
    ${twoSlides ? `transform: translateX(83.5%)` : 'translate: inherit'};
  }
`};
`;

export const Slide = styled.div`
  ${({ flexOrder, centralImage, oneSlide }) => `
    display: flex;
    flex: 1 0 75%;
    order: ${flexOrder};
    margin: ${oneSlide ? 'auto' : 'auto 20px auto auto'} 
    overflow: hidden;
    height: ${centralImage ? '250px' : '200px'};
    border-color: rgba(167, 169, 172, 0.5);
    border-style: solid;
    border-width: ${oneSlide ? '0px 0px 1px 0px' : '1px'};
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);

    @media ${minBp('tablet')} { 
      flex: 1 0 85%;
      height: ${oneSlide ? '450px' : '300px'} 
      ${centralImage ? 'height: 350px' : ''}
    }

    @media ${minBp('tabletLarge')} { 
      flex: 1 0 85%;
      height: ${oneSlide ? '100%' : '275px'} 
      ${centralImage && !oneSlide ? 'height: 325px' : ''}
      border-width: ${oneSlide ? '0px' : '1px'};
    }

    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: ${centralImage ? 'contain' : 'cover'};
    }

  `}
`;

export const SwipeableContainer = styled(Swipeable)`
  ${({ oneSlide }) => `
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
  margin-top: ${oneSlide ? '0' : '85px'};

  @media ${minBp('tabletLarge')} {
    margin-top: ${oneSlide ? '0' : '35px'};
    width: 50%;
  }
`};
`;

export const Pip = styled.button`
  ${({ active }) => `
  border-radius: 50%;
  height: 12px;
  width: 12px;
  padding: 0;
  margin-right: 10px;
  cursor: pointer;
  border: 1px solid #585a5f;
  background: ${active ? '#000' : 'rgba(167, 169, 172, 0.3)'}
`};
`;
